import Link from "@amzn/awsui-components-react/polaris/link";
import React from "react";
import { PC2_MIGRATION_FAQ_LINK } from "shared/util/constants/constantValues";

export const pc2MigrationDeadlineBanner = (setNotificationsItems) => {
  return {
    type: "info",
    content: (
      <React.Fragment>
        All partners must migrate by September 30th, 2026. Effective October 1,
        2026, partners who have not yet migrated to the new Partner Central
        experience will lose access to nearly all functionality in Partner
        Central, including submitting fund requests, managing claims, and
        creating or progressing opportunities. No data is lost, and all
        functionality (including in-progress workflows) resumes immediately upon
        completing migration. See{" "}
        <Link href={PC2_MIGRATION_FAQ_LINK} external>
          FAQ
        </Link>{" "}
        for details.
      </React.Fragment>
    ),
    dismissible: true,
    dismissLabel: "Dismiss message",
    onDismiss: () => setNotificationsItems([]),
    id: "pc2_migration_deadline_banner",
  };
};
